import React from "react";
import PropTypes from "prop-types";
import Video from "./components/video";
import classNames from "classnames";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";

const ParagraphVideo = ({ content }) => {
  const { simpleDesign } = useAccessibilityContext();

  const sectionClassNames = classNames({
      "paragraph paragraph-video": true,
      "small": !content.fieldBig || simpleDesign,
      "big": content.fieldBig && !simpleDesign,
      "highlighted": content.fieldHighlighted || simpleDesign,
    }),
    infoClassNames = classNames({
    "info-wrapper col-12": true,
    "col-md-6": true,
    }),
    rowClassNames = classNames({
    "row": true,
    "left": !content.fieldBig && content.fieldOrientation !== "right",
    "right": !content.fieldBig && content.fieldOrientation === "right"
  }),
    mediaClassNames = classNames({
      "media-wrapper col-12": true,
      "col-md-6": !content.fieldBig || simpleDesign
  });

  return (
    <section
      className={sectionClassNames}
      data-darkmode={content.fieldDarkMode}
    >
      <div className="container">
        <div className={rowClassNames}>
          <div className={mediaClassNames}>
            {content.fieldVideoFile &&
              <Video
                content={content.fieldVideoFile}
                label={content.fieldHeading}
                customThumbnail={content.fieldImage?.fieldMediaImage}
              />
            }
          </div>
          <div
            className={infoClassNames}
          >
            <div className="scroll-wrapper">
              <div className="text-wrapper">
                {content.fieldSubline && (
                  <h3 className="subline">{content.fieldSubline}</h3>
                )}
                {content.fieldHeading && (
                  <h2 className="headline">{content.fieldHeading}</h2>
                )}
                {content.fieldText && (
                  <div
                    tabIndex={0}
                    className="text allow-scrolling"
                    dangerouslySetInnerHTML={{
                      __html: content.fieldText,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const videoThumbnailPropTypes = {
  alt: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.shape({
    urlPath: PropTypes.string,
  }),
}

export const videoFilePropTypes = {
  thumbnail: PropTypes.shape(videoThumbnailPropTypes),
  mediaFileUrl: PropTypes.shape({
    path: PropTypes.string,
  }),
}

export const videoEmbedPropTypes = {
  thumbnail: PropTypes.shape(videoThumbnailPropTypes),
  fieldMediaOembedVideo: PropTypes.string,
}

ParagraphVideo.propTypes = {
  viewMode: PropTypes.string,
  content: PropTypes.shape({
    /* fieldVideoFile returns either type MediaEmbeddedVideo or MediaVideo */
    fieldVideoFile: PropTypes.oneOf([

      /* Video File */
      PropTypes.shape(videoFilePropTypes),

      /* Embedded Video (YouTube/Vimeo) */
      PropTypes.shape(videoEmbedPropTypes),
    ]),
  }),
};

export default ParagraphVideo;
